import { useEffect } from 'react'
import { throttle } from '../utils/throttle'

export default function usePhoneViewPortHack(): void {
  useEffect(() => {
    const refineVhValue = throttle(() => {
      const vh = window.innerHeight * 0.01
      // On iPhones, the 100vh unit can behave unexpectedly because the viewport
      // height changes when the browser navigation panel appears or disappears.
      // This will add a --vh property which equals 1% of an actual viewport
      // and could be used in css.
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }, 100)

    refineVhValue()
    window.addEventListener('resize', refineVhValue)

    return () => {
      window.removeEventListener('resize', refineVhValue)
    }
  }, [])
}
